<template>
  <!-- for /login page -->
  <button v-if="!isOnline && isMobileXsSm" class="nav-toggler account-nav-toggler" type="button" onclick="openMobileNav()">
    <span></span>
    <span></span>
    <span></span>
  </button>
  <!-- for /account page, logged users -->
  <button v-else-if="isOnline && isMobileXsSm" :class="{ 'account-nav-toggler': true, 'is-open': getShowSidebar}" type="button" @click="handleBtnToggleClick">
    <span></span>
    <span></span>
    <span></span>
  </button>
  <router-view />
</template>
<script setup>
import { computed, onBeforeMount } from 'vue'
import { useAuthUser } from '../../utils/stores/modules/authUser'
import { useMobileHelpers } from '../utils/composables/mobileHelpers'

// Props (defineProps)
// Emits (defineEmits)
// Reactive variables (inc composables)
const userStore = useAuthUser()
const { isMobileXsSm } = useMobileHelpers()
// Computed
const isOnline = computed(() => userStore.isOnline)
const getShowSidebar = computed (() => userStore.getShowSidebar)
// Methods
function openSidebar() {
  userStore.openSidebar()
}
function closeSidebar() {
  userStore.closeSidebar()
}
function handleBtnToggleClick() {
  if(getShowSidebar.value) closeSidebar()
  else openSidebar()
}
// Watchers
// Lifecycle Hooks
onBeforeMount(() => {
  var btn_toggle_nav_mobile = document.getElementById('btn-toggle-nav-mobile')
  btn_toggle_nav_mobile.style.display = 'none'
})
// Expose (defineExpose)
</script>
<script>
export default {
  name: 'AccountRoot'
}
</script>
<style lang="scss">
@use '../../../assets/sass/inc/default/grid/grid-vue-mixins.scss' as *;
  .account-nav-toggler {
		width: 30px;
		height: 30px;
		border: 0;
		@include transition(all 0.4s ease);
		display: inline-block;
		position: fixed;
		left: 20px;
		display: none;
		z-index: 101;
		cursor: pointer;

    top: 25px;
    @media (max-width: 575px) { top: 15px; }
		@media (min-width: 576px) and (max-width: 629px) { left: clamp(62px, calc((100vw - 1140px)/2 + 12px), 48px); }
		@media (min-width: 630px) and (max-width: 699px) { left: clamp(92px, calc((100vw - 1140px)/2 + 12px), 48px); }
		@media (min-width: 700px) and (max-width: 767px) { left: clamp(122px, calc((100vw - 1140px)/2 + 12px), 48px); }

		@include target-xs-lg {
			display: block;
		}

		span {
			width: 14px;
			height: 3px;
			position: absolute;
			left: 0;
			background-color: $brand-secondary;
			@include transition(all 0.3s);
			@include border-radius(3px);

			&:nth-child(1) {
				top: 5px;
				width: 22px;
			}
			&:nth-child(2) {
				top: 13px;
				width: 22px;
			}
			&:nth-child(3) {
				top: 21px;
			}
		}

    &.is-open{
      span:nth-child(1) {
        width: 22px;
        top: 14px;
        @include rotate(-45deg);
      }
      span:nth-child(2) {
        opacity: 0;
      }
      span:nth-child(3) {
        width: 22px;
        top: 14px;
        @include rotate(45deg);
      }
    }
	}
</style>